import router from '../router';

export default {
    getStepCart: (state, getters) => (key) => {

        if (getters.isCartEmpty) return [];

        return state.cart[state.kitId][key];
    },

    isKitStepEmpty: (state, getters) => (key) => {
        if (getters.isCartEmpt || typeof state.cart[state.kitId] === 'undefined' || typeof state.cart[state.kitId][key] === 'undefined') return false;

        return Object.keys(state.cart[state.kitId][key]).length > 0;
    },

    priceFormatter: () => (price) => {
        return new Intl.NumberFormat(document.documentElement.lang, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(price);
    },

    getCartDiscount: (state, getters) => {
        if (!state.current.discount || 
            state.cart[state.kitId] == null ||
            typeof state.cart[state.kitId] == 'undefined') return false;

        const steps = Object.entries(state.cart[state.kitId]);

        if (steps.length === state.current.groups.length) {
            
            return (getters.getCartTotal / 100) * parseFloat(state.current.discount);
        }

        return false;
    },

    isCartEmpty: state => {

        if (state.cart[state.kitId] == null) return true;

        return !(typeof state.cart[state.kitId] != 'undefined' && Object.keys(state.cart[state.kitId]).length);
    },

    getCartTotal: (state, getters) => {
        let total = 0;

        if (!getters.isCartEmpty) {

            // loop steps
            for (const [key, value] of Object.entries(state.cart[state.kitId])) {

                // loop products
                for (const [x, val] of Object.entries(Object.entries(value))) {

                    const product = val[1];
                    const price = product.variation ? product.variation.display_price : product.product.display_price;

                    total += price * product.qtt;
                }
            }

        }

        return total;
    },
    getAllCartProducts: (state, getters) => {

        if (getters.isCartEmpty) return false;

        const products = [];

        for (const [step, group] of Object.entries(state.cart[state.kitId])) {

            for (const [id, item] of Object.entries(Object.entries(group))) {
                
                let product = item[1];
                product.step = step;

                products.push(product);
            }

        }

        return products;
    },

    isOnOverview: state => {
        return router.currentRoute.value.fullPath === `/${state.kitId}/overview`;
    }
}